import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  namesRegex,
  emailRegex,
} from "../../shared/form-validators.directive";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UserProfileService } from "../../_services/userprofile.service";
import { Userprofile } from "../../_models/Userprofile";
import { AppConstants } from "src/app/constants/constants";

@Component({
  selector: "app-update-userprofile",
  templateUrl: "./update-userprofile.component.html",
  styleUrls: ["./update-userprofile.component.scss"],
})
export class UpdateUserprofileComponent implements OnInit {
  personalDetailsForm: FormGroup;
  loading = false;
  panelOpenState = false;
  userProfile: Userprofile;
  currentEmail: string = "";
  currentFirstName: string = "";
  currentLastName: string = "";

  constructor(
    private userProfileService: UserProfileService,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.getOwnUserProfile();

    this.personalDetailsForm = this.formBuilder.group(
      {
        firstName: [
          null,
          [ Validators.required, 
            Validators.pattern(namesRegex), 
            Validators.minLength(2),
            Validators.maxLength(64)
          ],
        ],
        lastName: [null, 
          [ Validators.required, 
            Validators.pattern(namesRegex), 
            Validators.minLength(2),
            Validators.maxLength(64)
          ],
        ],
        newEmail: [
          null, 
          [ Validators.pattern(emailRegex), 
            Validators.email]],
        confirmEmail: [
          null,
          [Validators.pattern(emailRegex), Validators.email],
        ],
        uniqueLearnerNumber : [],
        learnerNumber02 : []
      }
    );
  }

  getOwnUserProfile(): void {
    const valueDelim = (val: string | null) => !val || val === AppConstants.BLANK ? AppConstants.SECTION_DELIM : val;
    this.userProfileService.getOwnUserProfile$().subscribe(
      (data) => {
        this.userProfile = data;
        this.currentEmail = this.userProfile.email;
        this.currentFirstName = this.userProfile.firstName;
        this.currentLastName = this.userProfile.lastName;
        this.learnerNumber02.setValue(valueDelim(this.userProfile.learnerNumber02));
        this.uniqueLearnerNumber.setValue(valueDelim(this.userProfile.uniqueLearnerNumber));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  submitPersonalDetails(): void {
    if (!this.personalDetailsForm.valid) {
      return;
    }

    this.loading = true;
    this.updatePersonalDetails(this.personalDetailsForm.value);
  }

  updatePersonalDetails(value: Userprofile): void {
    value.id = this.userProfile.id;
    value.email = this.currentEmail;

    this.userProfileService.editUserProfile$(value).subscribe(
      (resp) => {
        this.userProfileService.onUserDetailsUpdate$.next(true);
        this.openSuccessfulSnackBar();
        this.clearForm(this.personalDetailsForm);
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.openUnsuccessfulSnackBar();
      }
    );
  }

  get firstName() {
    return this.personalDetailsForm.get(AppConstants.FIRST_NAME);
  }
  get lastName() {
    return this.personalDetailsForm.get(AppConstants.LAST_NAME);
  }
  get newEmail() {
    return this.personalDetailsForm.get(AppConstants.NEW_EMAIL);
  }
  get confirmEmail() {
    return this.personalDetailsForm.get(AppConstants.CONFIRM_EMAIL);
  }
  get learnerNumber02() {
    return this.personalDetailsForm.get(AppConstants.LEARNER_NUMBER02);
  }
  get uniqueLearnerNumber() {
    return this.personalDetailsForm.get(AppConstants.UNIQUE_LEARNER_NUMBER);
  }

  openSuccessfulSnackBar(): void {
    this._snackBar.open(AppConstants.USER_SUCCESSFUL_UPDATE_MESSAGE, null, {
      duration: 3000,
      horizontalPosition: AppConstants.CENTER,
      verticalPosition: AppConstants.BOTTOM,
      panelClass: [
        AppConstants.MAT_TOOLBAR,
        AppConstants.BG_SUCCESS,
        AppConstants.MAT_PRIMARY,
      ],
    });
  }

  openUnsuccessfulSnackBar(): void {
    this._snackBar.open(AppConstants.USER_UNSUCCESSFUL_UPDATE_MESSAGE, null, {
      duration: 3000,
      horizontalPosition: AppConstants.CENTER,
      verticalPosition: AppConstants.BOTTOM,
      panelClass: [
        AppConstants.MAT_TOOLBAR,
        AppConstants.BG_ERROR,
        AppConstants.MAT_PRIMARY,
      ],
    });
  }

  clearForm(form: FormGroup): void {
    this.loading = false;

    form.get(AppConstants.NEW_EMAIL).reset();
    form.get(AppConstants.CONFIRM_EMAIL).reset();
    form.markAsPristine();
    form.markAsUntouched();
    form.updateValueAndValidity();
  }
}
